// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const TABLES = [
//   "Projects",
//   "Clients",
//   "Consultants",
//   // "Project_Consultants",
//   "Financials",
//   "Tasks",
//   "Feedback",
// ];

// const allowedProjectColumns = [
//   "project_id",
//   "project_name",
//   "client_id",
//   "Address",
//   "start_date",
//   "end_date",
//   "status",
//   "project_type",
//   "description",
//   "Concerned_person",
//   "Bank_Guarantee_amount",
//   "Bank_Guarantee_date",
//   "EMD_amount",
//   "EMD_date",
// ];

// const DataTable = () => {
//   const baseUrl = process.env.REACT_APP_API_BASE_URL;
//   const [activeTab, setActiveTab] = useState("Projects");
//   const [dataMap, setDataMap] = useState({});
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const recordsPerPage = 10;

//   useEffect(() => {
//     TABLES.forEach((table) => fetchData(table));
//   }, []);

//   const fetchData = async (table) => {
//     try {
//       const res = await axios.get(`${baseUrl}/${table.toLowerCase()}`);
//       console.log(res);
//       setDataMap((prev) => ({ ...prev, [table]: res.data }));
//     } catch (err) {
//       console.error(`Error fetching ${table}:`, err);
//     }
//   };

//   const handleExport = () => {
//     const combined = TABLES.flatMap((table) => dataMap[table] || []);
//     if (combined.length === 0) return;

//     const allKeys = [...new Set(combined.flatMap((row) => Object.keys(row)))];
//     const csvRows = [
//       allKeys.join(","), // Header
//       ...combined.map((row) =>
//         allKeys.map((key) => `"${String(row[key] ?? "").replace(/"/g, '""')}"`).join(",")
//       ),
//     ];

//     const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = "all_tables_data.csv";
//     a.click();
//   };

//   const activeData = dataMap[activeTab] || [];

//   // ✅ Filter only allowed fields in Projects tab
//   const cleanedData =
//     activeTab === "Projects"
//       ? activeData.map((row) =>
//           Object.fromEntries(
//             Object.entries(row).filter(([key]) => allowedProjectColumns.includes(key))
//           )
//         )
//       : activeData;

//   const filtered = cleanedData.filter((item) =>
//     Object.values(item).some((val) =>
//       String(val).toLowerCase().includes(search.toLowerCase())
//     )
//   );

//   const startIdx = (page - 1) * recordsPerPage;
//   const paginated = filtered.slice(startIdx, startIdx + recordsPerPage);

//   return (
//     <div className="p-4 bg-white rounded shadow-md mt-8 w-full overflow-auto">
//       {/* Tabs */}
//       <div className="overflow-x-auto">
//         <div className="flex gap-2 border-b mb-4 min-w-max">
//           {TABLES.map((tab) => (
//             <button
//               key={tab}
//               onClick={() => {
//                 setActiveTab(tab);
//                 setSearch("");
//                 setPage(1);
//               }}
//               className={`px-4 py-2 text-sm font-medium border-b-2 capitalize transition duration-150 ${
//                 tab === activeTab
//                   ? "text-blue-600 border-blue-600"
//                   : "text-gray-600 border-transparent hover:text-blue-500 hover:border-gray-300"
//               }`}
//             >
//               {tab.replace(/_/g, " ")}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Search + Export (Responsive) */}
//       <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
//         <input
//           type="text"
//           className="border px-3 py-1 rounded w-full sm:w-64"
//           placeholder={`Search in ${activeTab}`}
//           value={search}
//           onChange={(e) => {
//             setSearch(e.target.value);
//             setPage(1);
//           }}
//         />
//         <button
//           onClick={handleExport}
//           className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full sm:w-auto"
//         >
//           Export CSV
//         </button>
//       </div>

//       {/* Table */}
//       <div className="overflow-auto [scrollbar-width:thin] [scrollbar-color:#a0aec0_#edf2f7]">
//         <table className="min-w-full border text-sm">
//           <thead className="bg-gray-100 text-left">
//             <tr>
//               {filtered[0] &&
//                 Object.keys(filtered[0]).map((key) => (
//                   <th key={key} className="p-2 border capitalize whitespace-nowrap">
//                     {key.replace(/_/g, " ")}
//                   </th>
//                 ))}
//             </tr>
//           </thead>
//           <tbody>
//             {paginated.length === 0 ? (
//               <tr>
//                 <td colSpan="100%" className="text-center p-4 text-gray-500 italic">
//                   No matching records
//                 </td>
//               </tr>
//             ) : (
//               paginated.map((row, i) => (
//                 <tr key={i} className="hover:bg-gray-50">
//                   {Object.values(row).map((val, j) => (
//                     <td key={j} className="p-2 border whitespace-nowrap">
//                       {String(val)}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-2">
//         <span className="text-sm text-gray-600">
//           Showing {startIdx + 1}–
//           {Math.min(startIdx + recordsPerPage, filtered.length)} of {filtered.length}
//         </span>
//         <div className="space-x-2">
//           <button
//             disabled={page === 1}
//             onClick={() => setPage((p) => p - 1)}
//             className={`px-3 py-1 rounded ${
//               page === 1
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-blue-500 text-white hover:bg-blue-600"
//             }`}
//           >
//             Prev
//           </button>
//           <button
//             disabled={startIdx + recordsPerPage >= filtered.length}
//             onClick={() => setPage((p) => p + 1)}
//             className={`px-3 py-1 rounded ${
//               startIdx + recordsPerPage >= filtered.length
//                 ? "bg-gray-200 text-gray-400 cursor-not-allowed"
//                 : "bg-blue-500 text-white hover:bg-blue-600"
//             }`}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DataTable;






import React, { useEffect, useState } from "react";
import axios from "axios";

const TABLES = [
  "Project",
  "Clients",
  "Consultants",
  // "Project_Consultants",
  "Financials",
  "Tasks",
  "Feedback",
];

const DataTable = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [activeTab, setActiveTab] = useState("Projects");
  const [dataMap, setDataMap] = useState({});
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    TABLES.forEach((table) => fetchData(table));
  }, []);

  const fetchData = async (table) => {
    try {
      const res = await axios.get(`${baseUrl}/${table.toLowerCase()}`);
      setDataMap((prev) => ({ ...prev, [table]: res.data }));
    } catch (err) {
      console.error(`Error fetching ${table}:`, err);
    }
  };

  const handleExport = () => {
    const combined = TABLES.flatMap((table) => dataMap[table] || []);
    if (combined.length === 0) return;

    const allKeys = [...new Set(combined.flatMap((row) => Object.keys(row)))];
    const csvRows = [
      allKeys.join(","), // Header
      ...combined.map((row) =>
        allKeys.map((key) => `"${String(row[key] ?? "").replace(/"/g, '""')}"`).join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "all_tables_data.csv";
    a.click();
  };

  const activeData = dataMap[activeTab] || [];

  // Show all fields for Projects and other tabs (no filtering)
  const cleanedData = activeData;

  const filtered = cleanedData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(search.toLowerCase())
    )
  );

  const startIdx = (page - 1) * recordsPerPage;
  const paginated = filtered.slice(startIdx, startIdx + recordsPerPage);

  return (
    <div className="p-4 bg-white rounded shadow-md mt-8 w-full overflow-auto">
      {/* Tabs */}
      <div className="overflow-x-auto">
        <div className="flex gap-2 border-b mb-4 min-w-max">
          {TABLES.map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setSearch("");
                setPage(1);
              }}
              className={`px-4 py-2 text-sm font-medium border-b-2 capitalize transition duration-150 ${
                tab === activeTab
                  ? "text-blue-600 border-blue-600"
                  : "text-gray-600 border-transparent hover:text-blue-500 hover:border-gray-300"
              }`}
            >
              {tab.replace(/_/g, " ")}
            </button>
          ))}
        </div>
      </div>

      {/* Search + Export */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
        <input
          type="text"
          className="border px-3 py-1 rounded w-full sm:w-64"
          placeholder={`Search in ${activeTab}`}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
        <button
          onClick={handleExport}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full sm:w-auto"
        >
          Export CSV
        </button>
      </div>

      {/* Table */}
      <div className="overflow-auto [scrollbar-width:thin] [scrollbar-color:#a0aec0_#edf2f7]">
        <table className="min-w-full border text-sm">
          <thead className="bg-gray-100 text-left">
            <tr>
              {filtered[0] &&
                Object.keys(filtered[0]).map((key) => (
                  <th key={key} className="p-2 border capitalize whitespace-nowrap">
                    {key.replace(/_/g, " ")}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {paginated.length === 0 ? (
              <tr>
                <td colSpan="100%" className="text-center p-4 text-gray-500 italic">
                  No matching records
                </td>
              </tr>
            ) : (
              paginated.map((row, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  {Object.values(row).map((val, j) => (
                    <td key={j} className="p-2 border whitespace-nowrap">
                      {String(val)}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-2">
        <span className="text-sm text-gray-600">
          Showing {startIdx + 1}–
          {Math.min(startIdx + recordsPerPage, filtered.length)} of {filtered.length}
        </span>
        <div className="space-x-2">
          <button
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
            className={`px-3 py-1 rounded ${
              page === 1
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            Prev
          </button>
          <button
            disabled={startIdx + recordsPerPage >= filtered.length}
            onClick={() => setPage((p) => p + 1)}
            className={`px-3 py-1 rounded ${
              startIdx + recordsPerPage >= filtered.length
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataTable;

